import React from 'react';

const UserActivity = ({ data }) => {

  return (
    <div></div>
  );
};

export default UserActivity;